import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { useTrackCustomEvent } from 'src/hooks/useTrackCustomEvent';

export const useInsightsL3NavState = () => {
  const [width, setLocalStorageWidth] = useLocalStorage('insightsL3Width');
  const [isOpen, setOpen] = useLocalStorage('isInsightsL3Open');
  const trackCustomEvent = useTrackCustomEvent();

  const setWidth = (newWidth: number) => {
    // Auto-close the nav if it's dragged to the min width. When the nav is
    // expanded again its width will be the min width + 1.
    if (newWidth <= 272) {
      onClose();
    } else {
      setLocalStorageWidth(newWidth);
    }
  };

  const onOpen = () => {
    setOpen(true);

    trackCustomEvent({
      category: 'Insights L3 List',
      action: 'selected_expand_list',
    });
  };

  const onClose = () => {
    setOpen(false);

    trackCustomEvent({
      category: 'Insights L3 List',
      action: 'selected_collapse_list',
    });
  };

  return { isOpen, onOpen, onClose, width, setWidth };
};
